import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 56,
    s: 2
  });
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        const seconds = current.h * 3600 + current.m * 60 + current.s;
        if (seconds <= 0) return current;
        const next = seconds - 1;
        return {
          h: Math.floor(next / 3600),
          m: Math.floor(next % 3600 / 60),
          s: next % 60
        };
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const formattedTime = `${String(timeLeft.h).padStart(2, '0')}:${String(timeLeft.m).padStart(2, '0')}:${String(timeLeft.s).padStart(2, '0')}`;
  return <div className="sticky top-0 z-50 w-full border-b border-brand-gold/50 bg-brand-ink text-brand-paper shadow-md" data-id="element-298" data-mp="1bveryb8d5j3g">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-3 px-3 py-2 text-[11px] font-medium sm:gap-5 md:px-6 md:py-2.5 md:text-sm" data-id="element-299" data-mp="1gtgc6zhizogi">
        <div className="flex items-center gap-1.5 whitespace-nowrap text-brand-goldLight" data-id="element-300" data-mp="27gj9ddqzwayz">
          <span className="relative flex h-2 w-2" data-id="element-301" data-mp="22lwx78d3aedu">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-amber opacity-75" data-id="element-302" data-mp="1xo57mkzx34ct" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-brand-amber" data-id="element-303" data-mp="1sr4vptgdz7ds" />
          </span>
          <strong className="tabular-nums" data-id="element-304" data-mp="2qd2b3hzgywli">94%</strong>
          <span className="hidden sm:inline" data-id="element-305" data-mp="2ler3ldwncy6g">de cupos tomados</span>
          <span className="sm:hidden" data-id="element-306" data-mp="2lceor9m6r3xm">cupos</span>
        </div>
        <span className="h-4 w-px bg-brand-gold/45" aria-hidden="true" data-id="element-307" data-mp="2ge3b0nsrs9a4" />
        <div className="flex items-center gap-1.5 whitespace-nowrap text-brand-paper" data-id="element-308" data-mp="2cecee3gkayxo">
          <ClockIcon className="h-3.5 w-3.5 text-brand-goldLight" aria-hidden="true" data-id="element-309" data-mp="14zzlbtt7t7av" />
          <span className="hidden sm:inline" data-id="element-310" data-mp="10ye8g8gokt0o">
            Precio de lanzamiento cierra en →
          </span>
          <span className="font-mono font-bold tabular-nums text-brand-goldLight" data-id="element-311" data-mp="12gut7stfy7d3">
            {formattedTime}
          </span>
        </div>
        <a href="#pricing" className="rounded-full border border-brand-gold/50 bg-brand-gold px-2.5 py-1 text-[10px] font-bold text-brand-ink transition-colors hover:bg-brand-goldLight focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-paper sm:px-3 sm:text-xs" data-id="element-312" data-mp="17ctj5kuf3xfm">
          VER KIT →
        </a>
      </div>
    </div>;
}